export default function KeyboardShortcuts() {
	window.addEventListener('keydown', key => {
		// metaKey is command on mac
		const ctrlOrMeta = key.ctrlKey || key.metaKey;
		if (!ctrlOrMeta || !key.altKey) {
			return;
		}
		let url;
		switch (key.which) {
			// ? to show list of commands
			case 191:
				let alertMsg = 'Keyboard Shortcuts:\nPress ctrl/cmd + alt/option + one of the following keys';
				alertMsg += '\na = admin';
				alertMsg += '\n+ = open create post';
				alertMsg += '\nh = open hub chooser';
				alertMsg += '\ni = insights';
				alertMsg += '\nL = logout (note it is uppercase)';
				alertMsg += '\n? = open this list';
				alert(alertMsg);
				break;
			// + to create post
			case 61:
				if (window.location.hash.match('#/posts')) {
					document.querySelector('.add-post-section').click();
				}
				break;
			// a to admin
			case 65:
				url = '#/admin/users';
				break;
			// h to open hub chooser
			case 72:
				document.querySelector('.current-client').click();
				break;
			// i to insights
			case 73:
				url = '#/posts';
				break;
			// L to logout - uppercase because ctrl + alt + l on ubuntu locks the computer
			case 76:
				if (key.shiftKey) {
					url = 'logout';
				}
				break;
		}
		if (url) {
			window.location.href = url;
		}
	});
}
